// extracted by mini-css-extract-plugin
export default {"header":"DrawerHeader_header__qRhFv","title":"DrawerHeader_title__hXNeE","subtitle":"DrawerHeader_subtitle__TojZl"};